export const isValidSIN = (sin = '') => {
  sin = sin.replace(/\D/g, '')
  if (sin.length !== 9) {
    return false
  }
  let sum = 0
  for (let i = 0; i < sin.length; i++) {
    let digit = parseInt(sin.charAt(i))
    if ((sin.length - i) % 2 === 0) {
      digit *= 2
      if (digit > 9) {
        digit -= 9
      }
    }
    sum += digit
  }
  return sum % 10 === 0
}
